import React from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'

import AddIcon from '@material-ui/icons/Add'
import { Grid } from '@material-ui/core'
import NumberFormat from 'react-number-format'

const Table35 = ({ tableProductionandLoss }) => {
  const columns = [
    // {
    //   title: 'Código',
    //   field: 'IdProductionAndLosseByClimate',
    //   sorting: false,
    //   filtering: false,
    //   // cellStyle: { background: '#009688' },
    //   // headerStyle: { color: '#fff' },
    // },
    {
      title: 'Rubro / Producto',
      field: 'Area',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Área de Producción',
      field: 'SubProjectHectares',
      filtering: false,
      align: 'center',
      render: (expense) => (
        <NumberFormat
          value={expense.SubProjectHectares}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
    {
      title: 'Antecedentes Evento climático más reciente',
      field: 'RecentClimaticEvent',
      align: 'center',
      grouping: false,
      filtering: false,
    },

    {
      title: 'Unidad',
      field: 'AnnualAverageYieldUnit',
      align: 'center',
      filtering: false,
    },
    {
      title: 'Cantidad',
      field: 'AnnualAverageYield',
      align: 'center',
      filtering: false,
    },
    {
      title: 'Unidad',
      field: 'AnnualEstimatedLossUnit',
      align: 'center',
      filtering: false,
    },
    {
      title: 'Cantidad',
      field: 'AnnualEstimatedLoss',
      align: 'center',
      filtering: false,
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableProductionandLoss}
            // actions={[
            //   {
            //     icon: () => <EditIcon style={{ color: '#0d53ad' }} />,
            //     tooltip: 'Editar',
            //     onClick: (event, rowData) => {
            //       setOpen(true)
            //       setBody(rowData)
            //     },
            //   },
            // ]}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',
              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={{ Add: () => <AddIcon style={{ color: 'green' }} /> }}
          />
        </Grid>
      </Grid>
      {/* <Modal35Edit
      open={open}
      setOpen={setOpen}
      body={body}
      setBody={setBody}
      getDataTableProductionAndLoss={getDataTableProductionAndLoss}
    /> */}
    </div>
  )
}

export default Table35
